import { graphql } from 'gatsby';
import React from 'react';
import Post, { PostProperties } from '../post';

const LabsPost = (props: PostProperties) => {
  return <Post {...props} postType={'labs'}></Post>;
};

export default LabsPost;

export const pageQuery = graphql`
  fragment blogpostBaseFields on ContentfulBlogPost {
    title
    excerpt
    fields {
      locale
    }
    slug
    socialImage: socialImage {
      file {
        url
      }
    }
    heroImage: image {
      title
      file {
        url
      }
    }
  }
  
  fragment blogpostFields on ContentfulBlogPost {
    ...blogpostBaseFields
    labels
    time
    pdfAttachment {
      file {
        url
      }
    }
    content {
      childMarkdownRemark {
        htmlAst
      }
    }
    metaDescription
  }
  
  query labsPostQuery($slug: String!, $locale: String!, $relatedArticlesSlugs: [String]!) {
    contentfulBlogPost(slug: {eq: $slug}, fields: {locale: {eq: $locale}}) {
      ...blogpostFields
    }
    relatedArticles: allContentfulBlogPost(
      filter: {slug: {in: $relatedArticlesSlugs}, fields: {locale: {eq: $locale}}, isLabsPost: {eq: true}}
      sort: {time: DESC}
    ) {
      edges {
        node {
          ...blogpostBaseFields
        }
      }
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`;
